import {
  isValidElement,
  MutableRefObject,
  ReactElement,
  Ref,
  useEffect,
  useMemo,
  useState,
} from "react";

export function isReactElement(x: unknown): x is ReactElement {
  return isValidElement(x);
}

let currentId = 1;

export function useElementId(id?: string) {
  return useMemo(() => id ?? `element-${currentId++}`, [id]);
}

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    if (value !== debounced) {
      const timeout = setTimeout(() => setDebounced(value), delayMs);
      return () => clearTimeout(timeout);
    }
  }, [value, debounced, delayMs]);
  return debounced;
}

export function mergeRefs<T>(
  ...refs: (((x: T | null) => void) | MutableRefObject<T | null> | Ref<T | null> | undefined)[]
) {
  return (x: T | null) => {
    for (const ref of refs) {
      if (typeof ref === "function") {
        ref(x);
      } else if (ref) {
        (ref as MutableRefObject<T | null>).current = x;
      }
    }
  };
}
